import { Box } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { SpecialPricingFormValues } from "./schemas"

import { FormDatePicker } from "@/components/UiKit"

interface EffectiveDateFieldsProps {
  productId: number
}

export const EffectiveDateFields: FC<EffectiveDateFieldsProps> = ({ productId }) => {
  const { control } = useFormContext<SpecialPricingFormValues>()

  return (
    <Box className='flex gap-3'>
      <FormDatePicker
        control={control}
        name='effectiveDate'
        label='Effective Date'
        required
        data-testid={`sales.product-pricing-form.effective-date-field-${productId}`}
      />
      <FormDatePicker
        control={control}
        name='validUntilDate'
        label='Valid Until Date'
        data-testid={`sales.product-pricing-form.valid-until-date-field-${productId}`}
      />
    </Box>
  )
}
